module.exports = function getResource(label, vars = []) {
    let resources = {
        share: 'Partager',
        copied: 'Copié',
        copy: 'Copier'
    };
    return resources[label];
};
